import PropTypes from 'prop-types'
import React, { Component } from 'react'
import IconSVG from 'svg-inline-react'

import CHAT_ICON_SRC from '!svg-inline?removeSVGTagAttrs=false?remoteTags=true!images/svg/chat.svg'

export default class SendMessageButton extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  }

  openNewConversation = () => {
    const { endUserId, inboxId } = this.props
    localStorage.setItem('ComposeConversationForEndUserId', endUserId)
    this.context.router.push(`/inboxes/${inboxId}`)
  }

  render() {
    const { disabled } = this.props
    return (
      <button
        disabled={disabled}
        className="drift-button drift-button-primary"
        style={{ width: '100%' }}
        onClick={this.openNewConversation}
      >
        <IconSVG src={CHAT_ICON_SRC}/>
        Send Message
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/shared/SendMessageButton/index.js